import { render, staticRenderFns } from "./FieldAndValue.vue?vue&type=template&id=f3c41892&scoped=true&"
import script from "./FieldAndValue.vue?vue&type=script&lang=ts&"
export * from "./FieldAndValue.vue?vue&type=script&lang=ts&"
import style0 from "./FieldAndValue.vue?vue&type=style&index=0&id=f3c41892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c41892",
  null
  
)

export default component.exports